import { assign, map, isEmpty, get } from "lodash";
import http from '../../api/index'
import store from '../../stores/index';
import { parseEquipment, parseConsumable, parseMeterReading } from '../../service/parser'

export default function createEquipmentModule() {
    const PAGE_LENGTH = 32;

    return {
        namespaced: true,

        state: () => ({
            items: [],
            currentItem: null,
            partial: true,
            consumables: [],
            meters: [],
            timestamp: Date.now(),
        }),

        getters: {
            items: (state) => state.items,
            currentItem: (state) => state.currentItem,
            consumables: (state) => state.consumables,
            meters: (state) => state.meters,
            partial: (state) => state.partial,
            timestamp: (state) => state.timestamp,
        },

        actions: {
            getAdminItems({ commit, state }, options = { page: 0 }) {
                if(options.page == 0){
                    commit('clearItems');
                }

                 let params = { client_id: options.clientID, limit: PAGE_LENGTH };

                 if( options.page){
                    params.offset = options.page * PAGE_LENGTH;
                 }

                 if(options.searchString){
                      params.serial_like = '%' + options.searchString + '%';
                 }else{
                      params.serial_like = '%';
                 }

                 let url;
                    let role = store.getters['profile/role'];
                 if(role === 'admin' || role === 'super-admin'){
                     url = 'admin/equipment/list';
                 }else{
                     url = 'group-admin/equipment/list';
                 }

                return http.get(url, {params:  params})
                    .then(res => {
                        let equipmentList = map(res.data.equipmentlist, (item) => {
                            return parseEquipment(item);
                        });
                        commit('pushItems', equipmentList);
                        commit('setPartial', res.data.partial_list);
                        return res.data;
                    })
            },

            getItems({ commit, state }, options = {page: 0}) {
                if(options.page == 0){
                    commit('clearItems');
                }

                let params = {limit: PAGE_LENGTH};

                if( options.page){
                    params.offset = options.page * PAGE_LENGTH;
                }

                if( options.clientID){
                    params.client_id = options.clientID;
                }

                if(options.searchString){
                    params.serial_like = '%' + options.searchString + '%';
                }else{
                    params.serial_like = '%';
                }

                return http.get('/equipment/list', {params:  params})
                    .then(res => {
                        let equipmentList = map(res.data.equipmentlist, (item) => {
                            return parseEquipment(item);
                        });
                        commit('pushItems', equipmentList);
                        commit('setPartial', res.data.partial_list);
                        return res.data;
                    })
            },

            clearCurrentItem({ commit }){
                commit('clearCurrentItem');
            },

            /*getItem({ commit, state, dispatch }, data) {
                let itemId = data.war_id;

                if(state.currentItem){
                    if(state.currentItem.id == itemId){
                        return state.currentItem;
                    }
                }

                if(state.items.length){
                    let equipment = state.items.find(item => {
                        return item.id == itemId;
                    });
                    if(equipment){
                        commit('setCurrentItem', equipment);
                        return equipment;
                    }
                }

                return dispatch('findItem', data);
            },*/


            findItem({ commit, state }, data = {}) {
                if(!data.war_id){
                    return;
                }
                let params = {
                    war_id: data.war_id,
                };
                if(data.clientID){
                    params.client_id = data.clientID;
                }

                return new Promise((resolve, reject) => {
                    http.get('/equipment/get', {params:  params})
                        .then(res => {
                            let item = res.data;
                            if(item.has_passcode){
                                resolve(item);
                                return;
                            }
                            if(item){
                                let equipment = parseEquipment(item);
                                commit('setCurrentItem', equipment);
                                resolve(res.data);
                                return;
                            }
                            resolve(null);
                        }).catch(err => {
                            reject(err);
                        });
                });

            },

            autoLogin({ commit, state }, data = {}) {
                if(!data.war_id){
                    return;
                }

                let params = {
                    war_id: data.war_id,
                };

                if(data.partial_serial){
                    params.partial_serial = data.partial_serial;
                }

                if(data.serial){
                    params.partial_serial = data.serial;
                }

                if(data.passcode){
                    params.passcode = data.passcode;
                }

                if(data.web_validation){
                    params.web_validation = data.web_validation;
                }

                return new Promise((resolve, reject) => {
                    http.get('/equipment/autologin', {params:  params})
                        .then(res => {
                            let item = res.data;
                            if(item.has_passcode){
                                resolve(item);
                                return;
                            }
                            if(item){
                                let equipment = parseEquipment(item);
                                commit('setCurrentItem', equipment);
                                resolve(res.data);
                                return;
                            }
                            resolve(null);
                        }).catch(err => {
                            reject(err);
                        }
                    );
                });

            },

            createRequestAccess({ commit }, data = {}) {
                return http.post('/request-access', data)
                    .then(res => {
                        return res.data;
                    })
            },

            createContact({ commit }, data = {}) {
                return http.post('/contact', data)
                    .then(res => {
                        return res.data;
                    })
            },

            createJobentry({ commit }, data = {}) {
                return http.post('/equipment/jobentry', data)
                    .then(res => {
                        let jobentry = assign({}, data, res.data);
                        return jobentry;
                    })
            },

            createOrder({ commit }, data = {}) {
                return http.post('/equipment/consumables/order', data)
                    .then(res => {
                        let order = assign({}, data, res.data);
                        return order;
                    })
            },

            getConsumables({ commit }, itemId) {
                return http.get('/equipment/consumables/list', {params:  {war_id: itemId}})
                    .then(res => {
                        let consumables = map(res.data.consumables, (item) => {
                            return parseConsumable(item);
                        });
                        commit('setConsumables', consumables);
                        return consumables;

                    });
            },
            getMeters({ commit }, itemId) {
                return http.get('/equipment/meters/list', {params:  {war_id: itemId}})
                    .then(res => {
                        let meters = map(res.data.meters, (item) => {
                            return parseMeterReading(item);
                        });
                        commit('setMeters', meters);
                        return meters;
                    });
            },
            updateMeters({ commit }, data = {}) {
                return new Promise((resolve, reject) => {
                    http.post('/equipment/meters/update', data).then(respond => {
                        let message = get(respond, 'data.friendly_error');
                        if(message){
                            reject(respond);
                        }else{
                            resolve(respond);
                        }
                    }).catch(err => {
                        reject(err);
                    });
                })

            },
        },

        mutations: {
            clearItems(state){
                state.items = [];
                state.timestamp = Date.now();
            },
            pushItems(state, items) {
                console.log(state.items.length);
                state.items.push(...items);
                console.log(state.items.length);
                state.timestamp = Date.now();
            },

            clearCurrentItem(state) {
                state.currentItem = null;
                state.timestamp = Date.now();
            },

            setCurrentItem(state, item) {
                state.currentItem = item;
                state.timestamp = Date.now();
            },

            setConsumables(state, items) {
                state.consumables = items;
                state.timestamp = Date.now();
            },

            setMeters(state, items){
                state.meters = items;
                state.timestamp = Date.now();
            },
            setPartial(state, value){
                state.partial = value;
                state.timestamp = Date.now();
            }
        },
    }
}
